
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#D2D5D9"}}),_c('path',{staticClass:"black-fill",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.353 7h7.263a5.359 5.359 0 015.352 5.353v7.263a5.359 5.359 0 01-5.352 5.352h-7.263A5.359 5.359 0 017 19.616v-7.263A5.359 5.359 0 0112.353 7zm7.264 16.162a3.545 3.545 0 003.545-3.545v-7.263a3.545 3.545 0 00-3.545-3.545h-7.263a3.545 3.545 0 00-3.545 3.545v7.263a3.545 3.545 0 003.545 3.545h7.263z","fill":"#fff"}}),_c('path',{staticClass:"black-fill",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.755 11.371a1.114 1.114 0 11-2.228 0 1.114 1.114 0 012.227 0zm-5.772-.035a4.653 4.653 0 00-4.647 4.647 4.653 4.653 0 004.647 4.648 4.653 4.653 0 004.648-4.648 4.653 4.653 0 00-4.648-4.647zm.001 7.488a2.84 2.84 0 110-5.68 2.84 2.84 0 010 5.68z","fill":"#fff"}})])
          )
        }
      }
    